<!--
/**
* @name: Add.vue
* @description: 添加门店
* @author: 杨波
* @create: 2020/08/11 09:40:37
* @update: 2020/08/11 09:40:37
*/
-->

<template>
  <y-view :loading="isLoading" class="dealers-wrapper">
    <template v-if="!isView">
      <div class="form-box">
        <y-form title="门店基本信息" id="basic" gutter="25px 30px" titleAlign="left" titleWidth="100px" contentWidth="100%">
          <y-form-item title="门店编码:">
            <k-input :class="css.input_width" v-model="editPara.code" clearable placeholder="按照编码规则自动生成" block disabled></k-input>
          </y-form-item>
          <y-form-item title="门店名称:" required>
            <k-input :class="css.input_width" v-model="editPara.name" clearable placeholder="请输入门店名称" block></k-input>
          </y-form-item>
          <y-form-item title="推广公司:" required>
            <k-select :class="css.input_width" placeholder="请选择推广公司" @change="changeCompany" block clearable v-model="editPara.companyCode">
              <k-option v-for="item in companyList" :key="item.code" :value="item.code" :label="item.name" :selected="editPara.companyCode == item.code">{{ item.name }}</k-option>
            </k-select>
          </y-form-item>
          <y-form-item title="DSR:" required>
            <k-auto-complete
              ref="au"
              :data="DSRList"
              v-model="DSRCode"
              key-field="code"
              value-field="name"
              search-field="name"
              layer-width=""
              placeholder="请选择DSR"
              @focus="onFocus"
              @toggle="onToggle"
              @input="onInput"
              :empty="empty"
              :text="text"
              :class="css.input_width"
            >
              <div slot-scope="{ row }" :key="row.code" class="list">
                <span class="name">{{ row.name }}</span>
              </div>
            </k-auto-complete>
          </y-form-item>
          <!-- <y-form-item title="营养顾问:" v-if="isEdit">
            <k-select :class="css.input_width" placeholder="只能查看，不可编辑" block disabled v-model="consultCode">
              <k-option v-for="item in consultList" :key="item.code" :value="item.code" :label="item.name" :selected="consultCode == item.code">{{ item.name }}</k-option>
            </k-select>
          </y-form-item> -->
          <y-form-item title="客商:" align="top" required>
            <k-auto-complete
              ref="au"
              :data="customerList"
              v-model="editPara.customerCode"
              key-field="customerCode"
              value-field="name"
              search-field="name"
              layer-width=""
              placeholder="请选择客商"
              @focus="onFocus"
              @toggle="onToggle"
              @input="onInput"
              :empty="empty"
              :text="text"
              :class="css.input_width"
            >
              <div slot-scope="{ row }" :key="row.customerCode" class="list">
                <span class="name">{{ row.name }}</span>
              </div>
            </k-auto-complete>
            <div :class="css.tip">注：如果不选择客商，门店审核时，系统将根据此条 门店信息自动创建新的客商信息。</div>
          </y-form-item>
          <y-form-item title="门店属性:" required>
            <k-select :class="css.input_width" placeholder="请选择门店属性" block clearable v-model="editPara.attribute">
              <k-option v-for="item in attributeList" :key="item.value" :value="item.value" :label="item.name" :selected="editPara.attribute == item.value">{{ item.name }}</k-option>
            </k-select>
          </y-form-item>
          <y-form-item title="门店性质:" required>
            <k-select :class="css.input_width" placeholder="请选择门店性质" block clearable v-model="editPara.type">
              <k-option v-for="item in characterList" :key="item.value" :value="item.value" :label="item.name" :selected="editPara.type == item.value">{{ item.name }}</k-option>
            </k-select>
          </y-form-item>
          <!-- <y-form-item title="门店等级:" v-if="isEdit">
            <k-select :class="css.input_width" placeholder="只能查看，不可编辑" block disabled v-model="editPara.shopGrade">
              <k-option v-for="item in shopGradeList" :key="item.value" :value="item.value" :label="item.name" :selected="editPara.shopGrade == item.value">{{ item.name }}</k-option>
            </k-select>
          </y-form-item> -->
          <!-- <y-form-item title="是否店中店:" v-if="isEdit">
            <k-select :class="css.input_width" placeholder="只能查看，不可编辑" block disabled v-model="editPara.isShopInShop">
              <k-option value="1" label="是" :selected="editPara.isShopInShop == '1'">是</k-option>
              <k-option value="2" label="否" :selected="editPara.isShopInShop == '2'">否</k-option>
            </k-select>
          </y-form-item> -->
          <!-- <y-form-item title="店中店等级:" v-if="isEdit && editPara.isShopInShop == '1'">
            <k-select :class="css.input_width" placeholder="只能查看，不可编辑" block disabled v-model="editPara.grade">
              <k-option v-for="item in gradeList" :key="item.value" :value="item.value" :label="item.name" :selected="editPara.grade == item.value">{{ item.name }}</k-option>
            </k-select>
          </y-form-item> -->
          <!-- <y-form-item title="门店R码:">
            <k-input :class="css.input_width" v-model="editPara.rCode" placeholder="请输入" block clearable></k-input>
          </y-form-item> -->
          <y-form-item title="门店地址:" required>
            <div>
              <k-select :class="css.selectW" placeholder="请选择省份" block clearable v-model="editPara.province">
                <k-option v-for="item in provinceList" :selected="editPara.province == item.areaCode" :key="item.areaCode" :value="item.areaCode" :label="item.areaName">{{ item.areaName }}</k-option>
              </k-select>
              <k-select :class="css.selectW" placeholder="请选择市" block clearable v-model="editPara.municipality">
                <k-option v-for="item in cityList" :selected="editPara.municipality == item.areaCode" :key="item.areaCode" :value="item.areaCode" :label="item.areaName">{{ item.areaName }}</k-option>
              </k-select>
              <k-select :class="css.selectW" placeholder="请选择区" block clearable v-model="editPara.district">
                <k-option v-for="item in countyList" :selected="editPara.district == item.areaCode" :key="item.areaCode" :value="item.areaCode" :label="item.areaName">{{ item.areaName }}</k-option>
              </k-select>
            </div>
          </y-form-item>
          <y-form-item title="详细地址:" required>
            <k-input :class="css.input_width" v-model="editPara.address" placeholder="请输入详细地址" block clearable></k-input>
          </y-form-item>
          <y-form-item title="联系人:" required>
            <k-input :class="css.input_width" v-model="editPara.contactUser" v-validate="'required|minLength(2)|maxLength(100)'" placeholder="请输入联系人姓名" block clearbale></k-input>
          </y-form-item>
          <y-form-item title="联系电话:" required>
            <k-input :class="css.input_width" v-validate="'regex(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)'" v-model="editPara.contactPhone" placeholder="请输入联系电话" clearable block></k-input>
          </y-form-item>
          <!-- <y-form-item title="面积:">
            <k-input :class="css.input_width" v-model="editPara.acreage" placeholder="请输入" block clearable></k-input>
          </y-form-item> -->
          <!-- <y-form-item title="员工数:">
            <k-input :class="css.input_width" v-model="editPara.staffNum" placeholder="请输入员工数" block clearable></k-input>
          </y-form-item> -->
          <y-form-item title="法人姓名:" required>
            <k-input :class="css.input_width" v-model="editPara.corporateName" placeholder="请输入法人姓名" block clearable></k-input>
          </y-form-item>
          <y-form-item title="法人身份证号:" required>
            <k-input :class="css.input_width" v-model="editPara.corporateIdentityCard" placeholder="请输入法人身份证号" block clearable></k-input>
          </y-form-item>
          <y-form-item title="营业执照名称:" required>
            <k-input :class="css.input_width" v-model="editPara.businessLicenseName" placeholder="请输入营业执照名称" block clearable></k-input>
          </y-form-item>
          <y-form-item title="统一社会信用代码:" required>
            <k-input :class="css.input_width" v-model="editPara.businessLicenseCode" placeholder="请输入统一社会信用代码" block clearable></k-input>
          </y-form-item>
          <y-form-item title="备注:" align="top">
            <k-input :class="css.textarea" v-model="editPara.remark" tag="textarea" block placeholder="请输入备注信息"></k-input>
          </y-form-item>
          <y-form-item title="状态:" required>
            <div>
              <k-radio v-model="editPara.status" value="1">启用</k-radio>
              <k-radio v-model="editPara.status" value="2">停用</k-radio>
            </div>
          </y-form-item>
          <y-form-item title="营业执照:" required align="top">
            <div class="row">
              <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploadedBusinessLicense"></y-upload-file>
              <y-image
                @delete="onDeleteLicense"
                v-dragging="{ list: businessLicense, item: img, group: 'image' }"
                v-for="(img, index) in businessLicense"
                :key="index"
                :index="index"
                :src="img"
              ></y-image>
            </div>
            <div class="mt-1">（只能上传1张，每张大小不超过 5M，建议尺寸750*750 px）</div>
          </y-form-item>
          <!-- <y-form-item title="食品经营许可证:" required align="top">
            <div class="row">
              <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploadedManageLicence"></y-upload-file>
              <y-image
                @delete="onDeleteManageLicence"
                v-dragging="{ list: manageLicence, item: img, group: 'image' }"
                v-for="(img, index) in manageLicence"
                :key="index"
                :index="index"
                :src="img"
              ></y-image>
            </div>
            <div class="mt-1">（只能上传1张，每张大小不超过 5M，建议尺寸750*750 px）</div>
          </y-form-item> -->
          <y-form-item title="身份证正面:" align="top" required>
            <div class="row">
              <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploadedIdCardFront"></y-upload-file>
              <y-image @delete="onDeleteFront" v-dragging="{ list: idCardFront, item: img, group: 'image' }" v-for="(img, index) in idCardFront" :key="index" :index="index" :src="img"></y-image>
            </div>
            <div class="mt-1">（只能上传1张，每张大小不超过 5M，建议尺寸750*750 px）</div>
          </y-form-item>
          <y-form-item title="身份证反面:" align="top" required>
            <div class="row">
              <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploadedIdCardReverse"></y-upload-file>
              <y-image @delete="onDeleteReverse" v-dragging="{ list: idCardReverse, item: img, group: 'image' }" v-for="(img, index) in idCardReverse" :key="index" :index="index" :src="img"></y-image>
            </div>
            <div class="mt-1">（只能上传1张，每张大小不超过 5M，建议尺寸750*750 px）</div>
          </y-form-item>
          <!-- <y-form-item title="门店内部照:" required align="top">
            <div class="row">
              <y-upload-file :uploadUrl="uploadUrl" @uploaded="onUploadedInnerImgList" fileType="image" multiple v-if="innerImgList.length < 5"></y-upload-file>
              <y-image @delete="onDeleteInner" v-dragging="{ list: innerImgList, item: img, group: 'image' }" v-for="(img, index) in innerImgList" :key="index" :index="index" :src="img"></y-image>
            </div>
            <div class="mt-1">（最多上传5张，每张大小不超过 5M，建议尺寸750*750 px）</div>
          </y-form-item>
          <y-form-item title="门店门头照:" required align="top">
            <div class="row">
              <y-upload-file :uploadUrl="uploadUrl" @uploaded="onUploadedHeadImgList" fileType="image" multiple v-if="headImgList.length < 5"></y-upload-file>
              <y-image @delete="onDeleteHead" v-dragging="{ list: headImgList, item: img, group: 'image' }" v-for="(img, index) in headImgList" :key="index" :index="index" :src="img"></y-image>
            </div>
            <div class="mt-1">（最多上传5张，每张大小不超过 5M，建议尺寸750*750 px）</div>
          </y-form-item> -->
        </y-form>
        <div class="spliter"></div>
        <y-form title="雀巢健康科学门店信息" id="hospital" gutter="25px 30px" titleAlign="left" titleWidth="120px" contentWidth="500px">
          <y-form-item title="医院编码:" align="top">
            <k-input :class="css.input_width" v-model="editPara.hospitalCode" maxlength="60" clearable placeholder="请输入医院编码" block></k-input>
          </y-form-item>
          <y-form-item title="医院名称:" align="top">
            <k-input :class="css.input_width" v-model="editPara.hospitalName" maxlength="60" clearable placeholder="请输入医院名称" block></k-input>
          </y-form-item>
          <y-form-item title="雀巢医务:" align="top">
            <k-input :class="css.input_width" v-model="editPara.nestleMedicine" maxlength="60" clearable placeholder="请输入雀巢医务" block></k-input>
          </y-form-item>
          <y-form-item title="雀巢门店编码:" align="top">
            <k-input :class="css.input_width" v-model="editPara.nestleRemark" maxlength="60" clearable placeholder="请输入雀巢门店编码" block></k-input>
          </y-form-item>
        </y-form>
        <div class="spliter"></div>
        <y-form title="银行打款信息" id="bank" gutter="25px 30px" titleAlign="left" titleWidth="120px" contentWidth="500px">
          <y-form-item title="打款类型:" align="top" required>
            <k-select clearable :class="css.input_width" v-model="editPara.bank.remitType">
              <k-option v-for="item in payTypeList" :key="item.value" :value="item.value" :label="item.name" :selected="editPara.bank.remitType == item.value">{{ item.name }}</k-option>
            </k-select>
          </y-form-item>
          <y-form-item title="银行名称:" align="top">
            <k-input :class="css.input_width" v-model="editPara.bank.bankName" clearable placeholder="请输入银行名称" block></k-input>
          </y-form-item>
          <y-form-item title="开户行:" align="top">
            <k-input :class="css.input_width" v-model="editPara.bank.depositBank" clearable placeholder="请输入开户银行名称" block></k-input>
          </y-form-item>
          <y-form-item title="行号:" align="top">
            <k-input :class="css.input_width" v-model="editPara.bank.bankNumber" clearable placeholder="请输入银行行号" block></k-input>
          </y-form-item>
          <y-form-item title="账户名称:" align="top">
            <k-input :class="css.input_width" v-model="editPara.bank.accountName" clearable placeholder="请输入账户名称" block></k-input>
          </y-form-item>
          <y-form-item title="银行卡号:" align="top">
            <k-input :class="css.input_width" v-model="editPara.bank.bankCardNumber" clearable placeholder="请输入银行卡号" block></k-input>
          </y-form-item>
          <y-form-item title="银行预留手机号码:" align="top">
            <k-input
              :class="css.input_width"
              v-validate="'regex(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)'"
              v-model="editPara.bank.bankReservedPhone"
              clearable
              placeholder="请输入银行预留手机号码"
              block
            ></k-input>
          </y-form-item>
          <y-form-item title="身份证号:" align="top">
            <k-input :class="css.input_width" v-model="editPara.bank.payeeIdCard" clearable placeholder="请输入身份证号" block></k-input>
          </y-form-item>
          <y-form-item title="身份证正面:" align="top">
            <div class="row">
              <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploadedBankIdCardFront"></y-upload-file>
              <y-image
                @delete="onDeleteBankFront"
                v-dragging="{ list: [editPara.bank.idCardFront], item: img, group: 'image' }"
                v-for="(img, index) in [editPara.bank.idCardFront]"
                :key="index"
                :index="index"
                :src="img"
              ></y-image>
            </div>
            <div class="mt-1">（只能上传1张，每张大小不超过 5M，建议尺寸750*750 px）</div>
          </y-form-item>
          <y-form-item title="身份证反面:" align="top">
            <div class="row">
              <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploadedBankIdCardReverse"></y-upload-file>
              <y-image
                @delete="onDeleteBankReverse"
                v-dragging="{ list: [editPara.bank.idCardReverse], item: img, group: 'image' }"
                v-for="(img, index) in [editPara.bank.idCardReverse]"
                :key="index"
                :index="index"
                :src="img"
              ></y-image>
            </div>
            <div class="mt-1">（只能上传1张，每张大小不超过 5M，建议尺寸750*750 px）</div>
          </y-form-item>
        </y-form>
      </div>
    </template>
    <template v-else>
      <y-form title="门店基本信息" id="basic" gutter="25px 30px" titleAlign="left" titleWidth="100px" contentWidth="100%">
        <y-form-item title="门店编码:">
          <span>{{ editPara.code }}</span>
        </y-form-item>
        <y-form-item title="主数据编码:">
          <span>{{ editPara.mainCustomerCode }}</span>
        </y-form-item>
        <y-form-item title="门店名称:" required>
          <span>{{ editPara.name }}</span>
        </y-form-item>
        <y-form-item title="推广公司:" required>
          <span>{{ editPara.companyCode | filterCompany(this.companyList) }}</span>
        </y-form-item>
        <y-form-item title="DSR:" required>
          <span>{{ DSRCode | filterCompany(this.DSRList) }}</span>
        </y-form-item>
        <!-- <y-form-item title="营养顾问:">
          <span>{{ consultCode | filterCompany(this.consultList) }}</span>
        </y-form-item> -->
        <y-form-item title="客商:" align="top">
          <span>{{ editPara.customerName }}</span>
          <div :class="css.tip">注：如果不选择客商，门店审核时，系统将根据此条 门店信息自动创建新的客商信息。</div>
        </y-form-item>
        <y-form-item title="门店属性:" required>
          <span>{{ editPara.attribute | filtertype(this.attributeList) }}</span>
        </y-form-item>
        <y-form-item title="门店性质:" required>
          <span>{{ editPara.type | filtertype(this.characterList) }}</span>
        </y-form-item>
        <!-- <y-form-item title="门店等级:">
          <span>{{ editPara.shopGrade | filtertype(this.shopGradeList) }}</span>
        </y-form-item> -->
        <!-- <y-form-item title="是否店中店:" required>
          <span>{{ editPara.isShopInShop == "2" ? "否" : "是" }}</span>
        </y-form-item> -->
        <!-- <y-form-item title="店中店等级:" required v-if="editPara.isShopInShop == '1'">
          <span>{{ editPara.grade | filtertype(this.gradeList) }}</span>
        </y-form-item> -->
        <!-- <y-form-item title="门店R码:">
          <span>{{ editPara.rCode }}</span>
        </y-form-item> -->
        <y-form-item title="门店地址:" required>
          <div>
            <k-select :class="css.selectW" placeholder="请选择省份" block disabled v-model="editPara.province">
              <k-option v-for="item in provinceList" :selected="editPara.province == item.areaCode" :key="item.areaCode" :value="item.areaCode" :label="item.areaName">{{ item.areaName }}</k-option>
            </k-select>
            <k-select :class="css.selectW" placeholder="请选择市" block disabled v-model="editPara.municipality">
              <k-option v-for="item in cityList" :selected="editPara.municipality == item.areaCode" :key="item.areaCode" :value="item.areaCode" :label="item.areaName">{{ item.areaName }}</k-option>
            </k-select>
            <k-select :class="css.selectW" placeholder="请选择区" block disabled v-model="editPara.district">
              <k-option v-for="item in countyList" :selected="editPara.district == item.areaCode" :key="item.areaCode" :value="item.areaCode" :label="item.areaName">{{ item.areaName }}</k-option>
            </k-select>
          </div>
        </y-form-item>
        <y-form-item title="详细地址:" required>
          <insensitive :val="editPara.address" type="address"></insensitive>
        </y-form-item>
        <y-form-item title="联系人:" required>
          <insensitive :val="editPara.contactUser" type="name"></insensitive>
        </y-form-item>
        <y-form-item title="联系电话:" required>
          <insensitive :val="editPara.contactPhone" type="phone"></insensitive>
        </y-form-item>
        <!-- <y-form-item title="面积:">
          <span>{{ editPara.acreage }}</span>
        </y-form-item> -->
        <!-- <y-form-item title="员工数:">
          <span>{{ editPara.staffNum }}</span>
        </y-form-item> -->
        <y-form-item title="法人姓名:">
          <insensitive :val="editPara.corporateName" type="name"></insensitive>
        </y-form-item>
        <y-form-item title="法人身份证号:">
          <insensitive :val="editPara.corporateIdentityCard" type="idCard"></insensitive>
        </y-form-item>
        <y-form-item title="营业执照名称:" required>
          <span>{{ editPara.businessLicenseName }}</span>
        </y-form-item>
        <y-form-item title="统一社会信用代码:" required>
          <span>{{ editPara.businessLicenseCode }}</span>
        </y-form-item>
        <y-form-item title="备注:" align="top">
          <span>{{ editPara.remark }}</span>
        </y-form-item>
        <y-form-item title="状态:" required>
          <span>{{ editPara.status == "0" ? "停用" : "启用" }}</span>
        </y-form-item>
        <y-form-item title="营业执照:" required align="top">
          <div class="row">
            <y-image v-dragging="{ list: businessLicense, item: img, group: 'image' }" v-for="(img, index) in businessLicense" :key="index" :index="index" :src="img"></y-image>
          </div>
          <div class="mt-1">（只能上传1张，每张大小不超过 5M，建议尺寸750*750 px）</div>
        </y-form-item>
        <!-- <y-form-item title="食品经营许可证:" required align="top">
          <div class="row">
            <y-image v-dragging="{ list: manageLicence, item: img, group: 'image' }" v-for="(img, index) in manageLicence" :key="index" :index="index" :src="img"></y-image>
          </div>
          <div class="mt-1">（只能上传1张，每张大小不超过 5M，建议尺寸750*750 px）</div>
        </y-form-item> -->
        <y-form-item title="身份证正面:" align="top">
          <div class="row">
            <y-image v-dragging="{ list: idCardFront, item: img, group: 'image' }" v-for="(img, index) in idCardFront" :key="index" :index="index" :src="img"></y-image>
          </div>
          <div class="mt-1">（只能上传1张，每张大小不超过 5M，建议尺寸750*750 px）</div>
        </y-form-item>
        <y-form-item title="身份证反面:" align="top">
          <div class="row">
            <y-image v-dragging="{ list: idCardReverse, item: img, group: 'image' }" v-for="(img, index) in idCardReverse" :key="index" :index="index" :src="img"></y-image>
          </div>
          <div class="mt-1">（只能上传1张，每张大小不超过 5M，建议尺寸750*750 px）</div>
        </y-form-item>
        <!-- <y-form-item title="门店内部照:" required align="top">
          <div class="row">
            <y-image v-dragging="{ list: innerImgList, item: img, group: 'image' }" v-for="(img, index) in innerImgList" :key="index" :index="index" :src="img"></y-image>
          </div>
          <div class="mt-1">（最多上传5张，每张大小不超过 5M，建议尺寸750*750 px）</div>
        </y-form-item>
        <y-form-item title="门店门头照:" required align="top">
          <div class="row">
            <y-image v-dragging="{ list: headImgList, item: img, group: 'image' }" v-for="(img, index) in headImgList" :key="index" :index="index" :src="img"></y-image>
          </div>
          <div class="mt-1">（最多上传5张，每张大小不超过 5M，建议尺寸750*750 px）</div>
        </y-form-item> -->
      </y-form>
      <div class="spliter"></div>
      <y-form title="雀巢健康科学门店信息" id="hospital" gutter="25px 30px" titleAlign="left" titleWidth="120px" contentWidth="500px">
        <y-form-item title="医院编码:" align="top">
          <span>{{ editPara.hospitalCode }}</span>
        </y-form-item>
        <y-form-item title="医院名称:" align="top">
          <span>{{ editPara.hospitalName }}</span>
        </y-form-item>
        <y-form-item title="雀巢医务:" align="top">
          <span>{{ editPara.nestleMedicine }}</span>
        </y-form-item>
        <y-form-item title="雀巢门店编码:" align="top">
          <span>{{ editPara.nestleRemark }}</span>
        </y-form-item>
      </y-form>
      <div class="spliter"></div>
      <y-form title="银行打款信息:" id="bank" gutter="25px 30px" titleAlign="left" titleWidth="120px" contentWidth="500px">
        <y-form-item title="打款类型:" align="top" required>
          <span>{{ editPara.bank.remitType | filtertype(this.payTypeList) }}</span>
        </y-form-item>
        <y-form-item title="银行名称:" align="top">
          <span>{{ editPara.bank.bankName }}</span>
        </y-form-item>
        <y-form-item title="开户行:" align="top">
          <span>{{ editPara.bank.depositBank }}</span>
        </y-form-item>
        <y-form-item title="行号:" align="top">
          <span>{{ editPara.bank.bankNumber }}</span>
        </y-form-item>
        <y-form-item title="账户名称:" align="top">
          <span>{{ editPara.bank.accountName }}</span>
        </y-form-item>
        <y-form-item title="银行卡号:" align="top">
          <insensitive :val="editPara.bank.bankCardNumber" type="bankCard"></insensitive>
        </y-form-item>
        <y-form-item title="银行预留手机号码:" align="top">
          <insensitive :val="editPara.bank.bankReservedPhone" type="phone"></insensitive>
        </y-form-item>
        <y-form-item title="身份证号:" align="top">
          <insensitive :val="editPara.bank.payeeIdCard" type="idCard"></insensitive>
        </y-form-item>
        <y-form-item title="身份证正面:" align="top">
          <div class="row">
            <y-image v-dragging="{ list: [editPara.bank.idCardFront], item: img, group: 'image' }" v-for="(img, index) in [editPara.bank.idCardFront]" :key="index" :index="index" :src="img"></y-image>
          </div>
          <div class="mt-1">（只能上传1张，每张大小不超过 5M，建议尺寸750*750 px）</div>
        </y-form-item>
        <y-form-item title="身份证反面:" align="top">
          <div class="row">
            <y-image
              v-dragging="{ list: [editPara.bank.idCardReverse], item: img, group: 'image' }"
              v-for="(img, index) in [editPara.bank.idCardReverse]"
              :key="index"
              :index="index"
              :src="img"
            ></y-image>
          </div>
          <div class="mt-1">（只能上传1张，每张大小不超过 5M，建议尺寸750*750 px）</div>
        </y-form-item>
      </y-form>
    </template>
    <div slot="bottom" v-if="!isView">
      <k-button @click="onReset" v-if="isEdit">重置</k-button>
      <k-button @click="onCancel(true, false)" v-else>取消</k-button>
      <k-button type="primary" @click="onSave" :disabled="saveButtonStatus">保存</k-button>
    </div>
    <y-anchor :anchor="anchorList" :class="css.anchor_box"></y-anchor>
  </y-view>
</template>

<script>
import {
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_DETAIL,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_LIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_LIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_ADD,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_UPDATE,
  // NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_STATUS_UPDATE,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CUSTOMER_LIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
  NESTLE_TRADE_BACK_SERVER_BASE_DATA_AREA_PROVIDER,
  NESTLE_TRADE_BACK_SERVER_BASE_DATA_AREA_LIST,
  NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
} from "@/assets/modules/apiList";

const initEditPara = () => ({
  code: "",
  name: "",
  companyCode: "",
  customerCode: "",
  attribute: "",
  type: "",
  isShopInShop: "1",
  grade: "grade03",
  shopGrade: "lv2",
  province: "",
  municipality: "",
  district: "",
  address: "",
  contactUser: "",
  contactPhone: "",
  mainCustomerCode: "",
  // acreage: "",
  // rCode: "",
  // staffNum: "",
  corporateName: "",
  corporateIdentityCard: "",
  businessLicenseName: "",
  businessLicenseCode: "",
  remark: "",
  status: "1",
  businessLicense: "",
  // manageLicence: "",
  idCardFront: "",
  idCardReverse: "",
  bank: {
    id: "",
    shopCode: "",
    remitType: "",
    bankName: "",
    depositBank: "",
    bankNumber: "",
    accountName: "",
    bankCardNumber: "",
    bankReservedPhone: "",
    payeeIdCard: "",
    idCardFront: "",
    idCardReverse: "",
  },
  hospitalCode: "",
  hospitalName: "",
  nestleMedicine: "",
  nestleRemark: "",
  shopCode: "",
  imageList: [],
  linkSalesmanList: [],
});
export default {
  data() {
    return {
      isLoading: false,
      editPara: initEditPara(),
      isSaving: false,
      isView: false,
      isEdit: false,
      DSRCode: "",
      // consultCode: "",
      companyList: [],
      uploadUrl: NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
      salemanList: [],
      customerList: [],
      typeList: [],
      attributeList: [],
      characterList: [],
      // gradeList: [],
      // shopGradeList: [],
      provinceList: [],
      cityList: [],
      countyList: [],
      payTypeList: [],
      // consultList: [],
      DSRList: [],
      businessLicense: [],
      // manageLicence: [],
      idCardFront: [],
      idCardReverse: [],
      // innerImgList: [],
      // headImgList: [],
      text: "",
      empty: "",
      selectStyle: {
        width: "114px",
      },
      anchorList: [
        {
          id: "basic",
          text: "基本信息",
        },
        {
          id: "hospital",
          text: "雀巢健康科学门店信息",
        },
        {
          id: "bank",
          text: "打款信息",
        },
      ],
      originData: {},
    };
  },
  computed: {
    saveButtonStatus() {
      let status = false;
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (!this.isView) {
        let name = para.name.toString().replace(/\s*/g, "");
        let contactUser = para.contactUser.toString().replace(/\s*/g, "");
        if (
          name.length < 2 ||
          contactUser.length < 2 ||
          !para.companyCode ||
          !this.DSRCode ||
          !para.type ||
          !para.attribute ||
          !para.province ||
          !para.municipality ||
          !para.district ||
          !para.address ||
          !/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(para.contactPhone) ||
          !para.businessLicenseName ||
          !para.businessLicenseCode ||
          !para.status ||
          (this.businessLicense && this.businessLicense.length === 0) ||
          // (this.manageLicence && this.manageLicence.length === 0) ||
          // (this.idCardFront && this.idCardFront.length === 0) ||
          // (this.idCardReverse && this.idCardReverse.length === 0) ||
          // (this.innerImgList && this.innerImgList.length === 0) ||
          // (this.headImgList && this.headImgList.length === 0) ||
          !para.bank.remitType
          //门店内部照/门头照
        ) {
          status = true;
        }
      }
      return status;
    },
  },
  watch: {
    "editPara.province"(nValue, oValue) {
      if (oValue) {
        this.editPara.municipality = "";
        this.editPara.district = "";
        this.cityList = [];
        this.countyList = [];
      }
      if (nValue) {
        this.changeProvince();
      }
    },
    "editPara.municipality"(nValue, oValue) {
      if (oValue) {
        this.editPara.district = "";
        this.countyList = [];
      }
      if (nValue) {
        this.changeCity();
      }
    },
    "editPara.companyCode"(nValue, oValue) {
      if (oValue) {
        this.DSRCode = "";
        this.consultCode = "";
      }
    },
  },
  methods: {
    onFocus() {},
    onToggle(e) {},
    onInput(text) {},
    onUploadedBusinessLicense(data) {
      this.businessLicense = [];
      this.businessLicense.push(data.data[0].url);
    },
    // onUploadedManageLicence(data) {
    //   this.manageLicence = [];
    //   this.manageLicence.push(data.data[0].url);
    // },
    onUploadedIdCardFront(data) {
      this.idCardFront = [];
      this.idCardFront.push(data.data[0].url);
    },
    onUploadedIdCardReverse(data) {
      this.idCardReverse = [];
      this.idCardReverse.push(data.data[0].url);
    },
    onUploadedBankIdCardFront(data) {
      this.editPara.bank.idCardFront = data.data[0].url;
    },
    onUploadedBankIdCardReverse(data) {
      this.editPara.bank.idCardReverse = data.data[0].url;
    },
    // onUploadedInnerImgList(data) {
    //   for (let i = 0; i < data.data.length; i++) {
    //     this.innerImgList.push(data.data[i].url);
    //   }
    // },
    // onUploadedHeadImgList(data) {
    //   for (let i = 0; i < data.data.length; i++) {
    //     this.headImgList.push(data.data[i].url);
    //   }
    // },
    changeCompany() {
      this.getTypeList();
    },
    getDealers(code) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_DETAIL,
        para: { shopCode: code },
      })
        .then((res) => {
          if (res) {
            if (!res.bank) {
              res.bank = this.editPara.bank;
            }
            if (res.businessLicense) {
              this.businessLicense.push(res.businessLicense);
            }
            // if (res.manageLicence) {
            //   this.manageLicence.push(res.manageLicence);
            // }
            if (res.idCardFront) {
              this.idCardFront.push(res.idCardFront);
            }
            if (res.idCardReverse) {
              this.idCardReverse.push(res.idCardReverse);
            }
            // for (let i = 0; i < res.imageList.length; i++) {
            //   if (res.imageList[i].category == "inner") {
            //     this.innerImgList.push(res.imageList[i].url);
            //   } else if (res.imageList[i].category == "head") {
            //     this.headImgList.push(res.imageList[i].url);
            //   }
            // }
            this.editPara = res;
            this.DSRCode = this.editPara.linkSalesmanList[0].salesmanCode;
            // this.editPara.acreage = this.editPara.acreage ? this.editPara.acreage : "";
            // this.editPara.rCode = this.editPara.rCode ? this.editPara.rCode : "";
            // this.editPara.staffNum = this.editPara.staffNum ? this.editPara.staffNum : "";
            // if (this.editPara.linkSalesmanList && this.editPara.linkSalesmanList.length > 1) {
            //   this.consultCode = this.editPara.linkSalesmanList[1].salesmanCode;
            // }
            this.isLoading = false;
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getCompanyList() {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_LIST,
        para: {},
      }).then((res) => {
        this.companyList = res;
      });
    },
    getSaleManList(id, type) {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_LIST,
        para: { type: id, companyCode: type == "consult" ? "" : this.editPara.companyCode },
      }).then((res) => {
        if (type == "DSR") {
          this.DSRList = res;
        } else {
          this.consultList = res;
        }
      });
    },
    //业务员类型
    getTypeList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
        para: {
          parentCode: "salesmanType",
        },
      }).then((res) => {
        for (let i = 0; i < res.length; i++) {
          if (res[i].name == "DSR") {
            this.getSaleManList(res[i].value, "DSR");
          } else {
            this.getSaleManList(res[i].value, "consult");
          }
        }
      });
    },
    //门店属性列表
    getAttrList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
        para: {
          parentCode: "storeNature",
        },
      }).then((res) => {
        this.attributeList = res;
      });
    },
    //门店性质列表
    getCharList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
        para: {
          parentCode: "storeCharacter",
        },
      }).then((res) => {
        this.characterList = res;
      });
    },
    //店中店等级列表
    // getGradeList() {
    //   this.$fetch({
    //     api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
    //     para: {
    //       parentCode: "storeinstoreGrade",
    //     },
    //   }).then((res) => {
    //     this.gradeList = res || [];
    //   });
    // },
    //店中店等级列表
    // getShopGradeList() {
    //   this.$fetch({
    //     api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
    //     para: {
    //       parentCode: "storeGrade",
    //     },
    //   }).then((res) => {
    //     this.shopGradeList = res || [];
    //   });
    // },
    //打款类型列表
    getPayTypeList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
        para: {
          parentCode: "payType",
        },
      }).then((res) => {
        this.payTypeList = res || [];
      });
    },
    getCustomerList() {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CUSTOMER_LIST,
        para: {
          status: 1,
        },
      }).then((res) => {
        this.customerList = res || [];
      });
    },
    getProvince() {
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_BASE_DATA_AREA_PROVIDER,
        para: {},
      }).then((res) => {
        this.provinceList = res;
      });
    },
    changeProvince() {
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_BASE_DATA_AREA_LIST,
        para: { atpid: this.editPara.province },
      }).then((res) => {
        this.cityList = res;
      });
    },
    changeCity() {
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_BASE_DATA_AREA_LIST,
        para: { atpid: this.editPara.municipality },
      }).then((res) => {
        this.countyList = res;
      });
    },
    onDeleteLicense(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.businessLicense.splice(obj.index, 1);
        },
      });
    },
    // onDeleteManageLicence(obj) {
    //   this.$dialog({
    //     title: "提示",
    //     content: "是否确认删除该图片？",
    //     ok: () => {
    //       this.manageLicence.splice(obj.index, 1);
    //     },
    //   });
    // },
    onDeleteFront(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.idCardFront.splice(obj.index, 1);
        },
      });
    },
    onDeleteReverse(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.idCardReverse.splice(obj.index, 1);
        },
      });
    },
    onDeleteBankFront(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.editPara.bank.idCardFront = "";
        },
      });
    },
    onDeleteBankReverse(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.editPara.bank.idCardReverse = "";
        },
      });
    },
    // onDeleteInner(obj) {
    //   this.$dialog({
    //     title: "提示",
    //     content: "是否确认删除该图片？",
    //     ok: () => {
    //       this.innerImgList.splice(obj.index, 1);
    //     },
    //   });
    // },
    // onDeleteHead(obj) {
    //   this.$dialog({
    //     title: "提示",
    //     content: "是否确认删除该图片？",
    //     ok: () => {
    //       this.headImgList.splice(obj.index, 1);
    //     },
    //   });
    // },
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "dealersManagement",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },
    onReset() {
      this.$refs.au.inputText = '';
      this.editPara = JSON.parse(JSON.stringify(this.originData));
    },
    onSave() {
      let { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      para.businessLicense = this.businessLicense[0];
      // para.manageLicence = this.manageLicence[0];
      para.idCardFront = this.idCardFront.length > 0 ? this.idCardFront[0] : "";
      para.idCardReverse = this.idCardReverse.length > 0 ? this.idCardReverse[0] : "";
      let imageList = [];
      // for (let i = 0; i < this.innerImgList.length; i++) {
      //   imageList.push({
      //     category: "inner",
      //     shopCode: this.shopCode ? this.shopCode : "",
      //     url: this.innerImgList[i],
      //     id: "",
      //   });
      // }
      // for (let i = 0; i < this.headImgList.length; i++) {
      //   imageList.push({
      //     category: "head",
      //     shopCode: this.shopCode ? this.shopCode : "",
      //     url: this.headImgList[i],
      //     id: "",
      //   });
      // }
      para.imageList = imageList;
      let linkSalesmanList = [];
      linkSalesmanList = [
        {
          id: para.linkSalesmanList.length > 0 && para.linkSalesmanList[0].id ? para.linkSalesmanList[0].id : "",
          salesmanCode: this.DSRCode,
          shopCode: para.linkSalesmanList.length > 0 && para.linkSalesmanList[0].shopCode ? para.linkSalesmanList[0].shopCode : "",
        },
        // {
        //   id: para.linkSalesmanList.length > 1 && para.linkSalesmanList[1].id ? para.linkSalesmanList[1].id : "",
        //   salesmanCode: this.consultCode,
        //   shopCode: para.linkSalesmanList.length > 1 && para.linkSalesmanList[1].shopCode ? para.linkSalesmanList[1].shopCode : "",
        // },
      ];
      for (let i = 0; i < linkSalesmanList.length; i++) {
        if (!linkSalesmanList[i].salesmanCode) {
          linkSalesmanList.splice(i, 1);
        }
      }
      para.linkSalesmanList = linkSalesmanList;
      if (this.isEdit) {
        para.bankUpdateDTO = para.bank;
      } else {
        para.bankDTO = para.bank;
      }
      this.isSaving = true;
      this.isLoading = false;
      this.$fetch({
        api: this.isEdit ? NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_UPDATE : NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_ADD,
        para,
      })
        .then((res) => {
          tip("操作成功");
          this.onCancel(true, true);
          this.isSaving = false;
          this.isLoading = false;
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
  },
  filters: {
    filterCompany(code, arr) {
      let tmp = [];
      arr.forEach((a) => {
        if (code == a.code) {
          tmp.push(a.name);
        }
      });
      return tmp.join(",");
    },
    filtertype(code, arr) {
      let tmp = [];
      arr.forEach((a) => {
        if (code == a.value) {
          tmp.push(a.name);
        }
      });
      return tmp.join(",");
    },
    filterCustomer(code, arr) {
      let tmp = [];
      arr.forEach((a) => {
        if (code == a.customerCode) {
          tmp.push(a.name);
        }
      });
      return tmp.join(",");
    },
  },
  created() {
    this.getCompanyList();
    this.getCustomerList();
    // this.getGradeList();
    // this.getShopGradeList();
    this.getCharList();
    this.getAttrList();
    this.getProvince();
    this.getPayTypeList();
    const { code, edit, view } = this.$route.query;
    if (code) {
      this.getDealers(code);
      this.shopCode = code;
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
        this.getTypeList();
      } else {
        this.isEdit = false;
        this.isView = false;
      }
    } else {
      this.isEdit = false;
      this.isView = false;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { code, edit, view } = to.query;
    this.editPara = initEditPara();
    this.DSRCode = "";
    // this.consultCode = "";
    this.businessLicense = [];
    // this.manageLicence = [];
    this.idCardFront = [];
    this.idCardReverse = [];
    // this.innerImgList = [];
    // this.headImgList = [];
    if (code) {
      this.getDealers(code);
      this.shopCode = code;
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
    } else {
      this.isEdit = false;
      this.isView = false;
    }
    next();
  },
};
</script>

<style lang="postcss" module="css">
.input_width {
  width: 400px !important;
}
.selectW {
  display: inline-block !important;
  margin-right: 10px;
  width: 125px !important;
}
.textarea {
  width: 400px !important;
  height: 200px;
  & :global(.k-textarea) {
    height: 200px !important;
    resize: none;
  }
}
.tip {
  width: 400px;
  margin-top: 10px;
  color: #f40d0d;
}
.anchor_box {
  width: 140px !important;
}
</style>
